<template>
  <v-dialog
      v-model="dialog"
      persistent
      max-width="290"
  >
    <v-card>
      <v-card-title class="text-subtitle-1">
        Confirma remover o produto?
      </v-card-title>
      <v-card-text class="py-0" v-text="product" />
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="darken-1"
            text
            @click="$emit('close')"
        >
          Cancelar
        </v-btn>
        <v-btn
            color="primary darken-1"
            text
            @click="$emit('confirm')"
        >
          Confirmar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DeleteProductCart",
  props: ['dialog', 'product']
}
</script>

<style scoped>

</style>